import { useEffect, useState } from "react";
import { useAuth, authApi, formatApiError } from "../AuthContext";
import {
  Users, CalendarDays, Inbox, Megaphone, Dumbbell, GraduationCap, ArrowUpRight,
} from "lucide-react";

export default function Overview({ onNavigate }) {
  const { user } = useAuth();
  const [stats, setStats] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    Promise.all([
      authApi.get("/admin/branches"),
      authApi.get("/admin/courses"),
      authApi.get("/admin/events"),
      authApi.get("/admin/announcements"),
      authApi.get("/admin/event-registrations"),
      authApi.get("/admin/coach-applications"),
      authApi.get("/admin/contact-messages"),
    ])
      .then(([b, c, e, a, er, ca, cm]) => {
        setStats({
          branches: b.data.length,
          activeBranches: b.data.filter((x) => x.is_active).length,
          courses: c.data.length,
          events: e.data.length,
          announcements: a.data.length,
          eventRegistrations: er.data.length,
          coachApplications: ca.data.length,
          contactMessages: cm.data.length,
        });
      })
      .catch((err) => setError(formatApiError(err)));
  }, []);

  return (
    <div data-testid="admin-overview">
      <div className="mb-8">
        <div className="eyebrow mb-2">Yönetim Paneli</div>
        <h1 className="heading-lg">Hoş geldin, <span className="text-primary">{user?.name || "Admin"}</span></h1>
        <p className="mt-2 text-muted-foreground">Sitenin tüm içeriğini buradan yönetebilirsin.</p>
      </div>

      {error && <div className="card-elev p-4 border-destructive/40 mb-6 text-destructive text-sm">{error}</div>}

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        <Stat icon={Dumbbell} label="Branş" value={stats?.branches} sub={`${stats?.activeBranches || 0} aktif`} testid="stat-branches" onClick={() => onNavigate("branches")} />
        <Stat icon={GraduationCap} label="Kurs" value={stats?.courses} testid="stat-courses" onClick={() => onNavigate("courses")} />
        <Stat icon={CalendarDays} label="Etkinlik" value={stats?.events} testid="stat-events" onClick={() => onNavigate("events")} />
        <Stat icon={Megaphone} label="Duyuru" value={stats?.announcements} testid="stat-announcements" onClick={() => onNavigate("announcements")} />
      </div>

      <div className="mb-3">
        <h2 className="heading-md">Form Gönderimleri</h2>
        <p className="text-sm text-muted-foreground">Sitedeki formlardan gelen başvuru ve mesajlar.</p>
      </div>
      <div className="grid sm:grid-cols-3 gap-4">
        <Stat icon={Users} label="Etkinlik Kayıtları" value={stats?.eventRegistrations} accent testid="stat-eventregs" onClick={() => onNavigate("submissions")} />
        <Stat icon={Inbox} label="Antrenör Başvuruları" value={stats?.coachApplications} accent testid="stat-coachapps" onClick={() => onNavigate("submissions")} />
        <Stat icon={Inbox} label="İletişim Mesajları" value={stats?.contactMessages} accent testid="stat-contacts" onClick={() => onNavigate("submissions")} />
      </div>
    </div>
  );
}

function Stat({ icon: Icon, label, value, sub, accent, testid, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testid}
      className={`card-elev p-5 text-left group ${accent ? "ring-1 ring-primary/20" : ""}`}
    >
      <div className="flex items-center justify-between mb-4">
        <div className="h-10 w-10 rounded-md bg-primary/10 ring-1 ring-primary/20 flex items-center justify-center text-primary">
          <Icon className="h-5 w-5" />
        </div>
        <ArrowUpRight className="h-4 w-4 text-muted-foreground group-hover:text-primary transition-colors" />
      </div>
      <div className="font-display text-4xl font-black text-foreground leading-none">{value ?? "—"}</div>
      <div className="mt-2 text-[10px] font-display font-bold uppercase tracking-[0.22em] text-muted-foreground">{label}</div>
      {sub && <div className="mt-1 text-xs text-primary">{sub}</div>}
    </button>
  );
}
